import React from "react";
import style from "./Switch.module.css";

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  name?: string;
  id?: string;
  disabled?: boolean;
  label?: React.ReactNode;
}

const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  name,
  id,
  disabled = false,
  label,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(e.target.checked);
    }
  };

  return (
    <div className={`${style.wrapper} ${disabled ? style.disabled : ""}`}>
      <label className={style.track} data-checked={checked}>
        <input
          type="checkbox"
          className={style.input}
          name={name}
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          role="switch"
          aria-checked={checked}
        />
        <span className={style.thumb} />
      </label>
      {label != null && (
        <span className={style.label} onClick={() => !disabled && onChange(!checked)}>
          {label}
        </span>
      )}
    </div>
  );
};

export default Switch;
